import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireDatabaseModule } from '@angular/fire/database';

import { CarouselModule } from 'ngx-bootstrap/carousel';
import { AlertModule } from 'ngx-bootstrap/alert';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';


import { NgxDropzoneModule } from 'ngx-dropzone';
import { QuillModule } from 'ngx-quill';



import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
 
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { SigninComponent } from './users/signin/signin.component';
import { SignupComponent } from './users/signup/signup.component';
import { LandingComponent } from './landing/landing.component';
import { ProfileComponent } from './users/profile/profile.component';
import { ForgotPasswordComponent } from './users/forgot-password/forgot-password.component';
import { PasswordResetEmailSentComponent } from './users/password-reset-email-sent/password-reset-email-sent.component';
import { ResetPasswordComponent } from './users/reset-password/reset-password.component';
import { ResetPasswordSuccessComponent } from './users/reset-password-success/reset-password-success.component';
import { VerificationSuccessfulComponent } from './users/verification-successful/verification-successful.component';
import { SignupSuccessfulComponent } from './users/signup-successful/signup-successful.component';
import { NavComponent } from './components/nav/nav.component';
import { ProjectComponent } from './project/project.component';
import { BookmarksComponent } from './bookmarks/bookmarks.component';
import { ReferencesComponent } from './references/references.component';
import { CanvasComponent } from './canvas/canvas.component';

import { LinkCarouselComponent } from './components/link-carousel/link-carousel.component';

import { ServiceWorkerModule } from '@angular/service-worker';
import { ImagePreloadDirective } from './directives/image-preload.directive';
import { environment } from '../environments/environment';

import { DateAgoPipe } from './pipes/date-ago.pipe';

@NgModule({
  declarations: [
    AppComponent,
    SigninComponent,
    SignupComponent,
    LandingComponent,
    ForgotPasswordComponent,
    PasswordResetEmailSentComponent,
    ResetPasswordComponent,
    ResetPasswordSuccessComponent,
    VerificationSuccessfulComponent,
    SignupSuccessfulComponent,
    ImagePreloadDirective,
    ProfileComponent,
    NavComponent,
    ProjectComponent,
    BookmarksComponent,
    ReferencesComponent,
    CanvasComponent,
    LinkCarouselComponent,
    DateAgoPipe,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CommonModule,
    RouterModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    CarouselModule.forRoot(),
    AlertModule.forRoot(),
    CollapseModule.forRoot(),
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    QuillModule.forRoot(),
    ModalModule.forRoot(),
    NgxDropzoneModule,
    AccordionModule.forRoot(),
    ProgressbarModule.forRoot(),
    PerfectScrollbarModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    MatProgressBarModule,
    MatProgressSpinnerModule
  ],
  exports: [
    NavComponent
  ],
  providers: [{
    provide: PERFECT_SCROLLBAR_CONFIG,
    useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
